import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '@services';

@Directive({
    selector: '[availableForUserWithAuthStatus]'
})
export class AvailableForUserWithAuthStatusDirective {
    public readonly authStatus = input.required<boolean>({
        alias: 'availableForUserWithAuthStatus'
    });

    private readonly authService = inject(AuthService);
    private readonly viewContainerRef = inject(ViewContainerRef);
    private readonly templateRef = inject(TemplateRef);

    constructor() {
        effect(() => {
            const isAuthorized = this.authService.isAuthorized();

            this.viewContainerRef.clear();

            if (isAuthorized === this.authStatus()) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
            }
        });
    }
}
